import React from "react";
import Translate from "react-translate-component";
export const FileWrite = () => {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
    component: "span",
    content: "proposal.file_write"
  }));
};